import { ref } from 'vue'
import { defineStore } from 'pinia'
import useCrudStore from '@/hooks/useCrudStore'
import {
  fetchItem,
  fetchItems,
  importItems,
  createItem,
  updateItem,
  destroyItem,
  bulkUpdate
} from '@/apps/traforama/api/spotsLists'
import {
  ISpotsListFilter,
  ISpotsListImportPayload,
  ISpotListBulkUpdateAttributes,
  ISpotsListImportAttributes
} from '@/apps/traforama/interfaces/spotsLists'

const defaultFilter: ISpotsListFilter = {}

export const useSpotsListsStore = defineStore('spotsLists', () => {
  const importResult = ref<ISpotsListImportAttributes>({
    total: 0,
    valid: 0,
    invalid: 0
  })

  const {
    currentItems,
    total,
    filter,
    selected,
    items,
    current,
    listLoading,
    itemsLoading,
    currentPage,
    FetchItems,
    FetchItem,
    SaveItem,
    DestroyItem,
    SetCurrentPage,
    SetSelection,
    SetFilters,
    SetCurrent,
    error,
    itemById,
    payload,
    setItems,
    setCurrentItems,
    setTotal,
    removeItem
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    fetchItem,
    createItem,
    updateItem,
    destroyItem
  })

  const BulkUpdate = async (item: ISpotListBulkUpdateAttributes) => {
    listLoading.value = true
    try {
      const response = await bulkUpdate(item)
      return response.data
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  const DestroyItems = async (ids: string[]) => {
    listLoading.value = true
    try {
      await Promise.all(ids.map((id) => destroyItem(id)))
      ids.forEach((id) => removeItem(id))
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  const ImportItems = async (spotList: ISpotsListImportPayload) => {
    listLoading.value = true
    try {
      const response = (await importItems(spotList)) as any
      importResult.value = response.data.attributes
      return response.data
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  return {
    // State
    currentItems,
    filter,
    total,
    currentPage,
    listLoading,
    selected,
    current,
    importResult,

    // Actions
    SetFilters,
    FetchItems,
    SaveItem,
    SetCurrentPage,
    DestroyItem,
    SetCurrent,
    DestroyItems,
    BulkUpdate,
    FetchItem,
    SetSelection,
    ImportItems
  }
})
